import { CanDeactivateFn } from '@angular/router';
import type { OrderEditPageComponent } from './order-edit-page.component';

/** `canDeactivate` of the change of an order: the page decides — with something to lose the operator is asked («Выйти без сохранения?»), and the lock is let go whichever way the page is left. A type-only import: the page stays in its lazy chunk. */
export const canLeaveEditPage: CanDeactivateFn<OrderEditPageComponent> = component => component.canLeave();
